import styled, { css } from 'styled-components'

import { color } from 'src/styles/colors'
import { fontWeight, fontSize } from 'src/styles/fonts'
import { media } from 'src/styles/media'

export const UnorderedList = styled.ul`
  padding: 0;
`

export const ListItem = styled.li`
  list-style-type: none;
  padding: 0 2rem;

  :hover {
    background-color: ${color.VERY_LIGHT_PINK};
  }
`

export const InnerLinkWrap = styled.div`
  display: flex;
  align-items: center;
`

export const SpacingWrap = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-grow: 1;
  margin-left: 1.6rem;
  border-bottom: 0.1rem solid ${color.VERY_LIGHT_PINK};
  min-height: 7.8rem;

  ${media.desktop} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const ImageWrap = styled.div`
  width: 4.8rem;
  height: 4.8rem;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-content: center;
  align-items: center;
`

export const ProfilePicture = styled.img`
  max-width: 100%;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const NotificationText = styled.p`
  color: ${color.WARM_GREY};
  text-align: left;
`

export const TextPart = styled.span<{ isHighlighted: boolean }>`
  ${({ isHighlighted }) =>
    isHighlighted
      ? css`
          font-weight: ${fontWeight.EXTRA};

          :last-child {
            color: ${color.DULL_ORANGE};
          }
        `
      : ''}
`

export const ButtonsWrap = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.6rem;

  ${media.desktop} {
    margin-bottom: 0;
  }
`

export const Button = styled.button<{ secondary?: boolean }>`
  border-radius: 2.4rem;
  background-color: ${({ secondary }) =>
    secondary ? 'rgba(87, 61, 57, 0.15)' : color.DUSTY_ORANGE};
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontWeight.EXTRA};
  color: ${({ secondary }) => (secondary ? color.WARM_GREY : color.WHITE)};
  padding: 0.8rem 2.4rem;

  & + & {
    margin-left: 1.2rem;
  }
`

export const GetMoreWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`

export const ButtonLink = styled.button`
  padding: 0;
  width: 100%;
`
